import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripMatch, TripMatchStatus, TripRequest } from '@marageti/z4-sdk/lib/travel';
import TripCancelView from './trip-cancel-view';
import { BackNavigationView } from '../../../components/back-navigation';
import { getTripRequestBackNavConfig } from '../../../components/back-navigation/back-navigation-configs';
import { useBackNavigation } from '../../../hooks/use-back-navigation';
import { joinDestinationNames } from '../../../utils/helpers';

const TripCancelContainer = () => {
  const { tripRequestId } = useParams();
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const { primaryText, handleBack } = useBackNavigation(getTripRequestBackNavConfig);

  const { data: tripRequest } = useFetch<TripRequest>(
    apiClient.tripRequestsClient.getTripRequest,
    [tripRequestId],
    !!tripRequestId,
  );

  const { data: matches } = useFetch<TripMatch[]>(
    apiClient.tripRequestsClient.getTripRequestTripMatches,
    [tripRequestId],
    !!tripRequestId,
  );

  const activeMatches = matches?.filter(
    (match) => match.status !== TripMatchStatus.MatchTravelerCanceled && match.status !== TripMatchStatus.MatchPartnerCanceled,
  ) || [];

  const handleCancel = () => {
    navigate(`/trip-requests/${tripRequestId}`);
  };

  const country = tripRequest?.destinations ? joinDestinationNames(tripRequest.destinations, ',') : '';

  return (
    <>
      <BackNavigationView primaryText={primaryText} handleBack={handleBack} dataE2e="ztest-cancel-trip-back" />
      <TripCancelView
        tripMatches={activeMatches}
        onCancel={handleCancel}
        country={country}
      />
    </>
  );
};

export default TripCancelContainer;
